import { NA } from './format';

/** 5000 → "$5K", 100000 → "$100K", from the response's `account_size`. */
export const formatAccountSize = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return NA;
  if (n >= 1e6) return `$${Number((n / 1e6).toFixed(2))}M`;
  if (n >= 1e3) return `$${Number((n / 1e3).toFixed(n % 1e3 ? 1 : 0))}K`;
  return `$${n.toLocaleString('en-US')}`;
};

/** TradeLocker logins arrive already prefixed ("D#1426153") — hash the rest. */
export const formatLoginId = (loginId) =>
  /^\d/.test(loginId ?? '') ? `#${loginId}` : (loginId ?? NA);

/**
 * An account's plan as the app writes it, from the response's `plan_type`
 * ("alpha pro 8%" → "Alpha Pro 8%"). Each word capitalised, the rest left as
 * sent, so a "%" or a size in the name passes through.
 */
export const formatPlanName = (plan) => {
  const text = String(plan ?? '').trim();
  return text ? text.replace(/(^|\s)(\S)/g, (_, gap, ch) => gap + ch.toUpperCase()) : NA;
};

/**
 * An account state as the client reads it. Alpha's word is "Qualified" — the
 * API still says "Funded" in places (TI review E3), and "Funded" must not
 * reach the screen. Every other state passes through.
 */
export const accountStateLabel = (state) =>
  typeof state === 'string' ? state.replace(/\bfunded\b/gi, 'Qualified') : state;
